import React, { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { canAccessOzelDosyalar } from '../utils/ozelDosyaAccess';
import KisiselGiderler from '../components/Kasa/KisiselGiderler';
import './KisiselGiderlerSayfasi.css';

/**
 * Kisisel giderler kendi sayfasinda durur — ofis kasasinin bir sekmesi
 * degil. Iki sebep: bunlar ofis kasasiyla hicbir hesap iliskisi olmayan
 * ozel kayitlar, ve telefondan tek dokunusla acilabilmesi gerekiyor
 * (/kisisel-giderler dogrudan bu sayfayi acar).
 */

const AYLAR = [
  { value: 1, label: 'Ocak' }, { value: 2, label: 'Şubat' }, { value: 3, label: 'Mart' },
  { value: 4, label: 'Nisan' }, { value: 5, label: 'Mayıs' }, { value: 6, label: 'Haziran' },
  { value: 7, label: 'Temmuz' }, { value: 8, label: 'Ağustos' }, { value: 9, label: 'Eylül' },
  { value: 10, label: 'Ekim' }, { value: 11, label: 'Kasım' }, { value: 12, label: 'Aralık' },
];

const KisiselGiderlerSayfasi = () => {
  const { user } = useAuth();
  const [yil, setYil] = useState(new Date().getFullYear());
  const [ay, setAy] = useState(new Date().getMonth() + 1);
  /* Widget'tan "Gider ekle" ile gelindiginde adres ?ekle=1 tasiyor. */
  const [adresParam] = useSearchParams();
  const hemenEkle = adresParam.get('ekle') === '1';

  if (!canAccessOzelDosyalar(user)) {
    return (
      <div className="kgs-container">
        <header className="kgs-header"><h1>Kişisel Giderler</h1></header>
        <p className="kgs-bos">Bu sayfaya erişim yetkiniz bulunmamaktadır.</p>
      </div>
    );
  }

  const oncekiAy = () => {
    if (ay === 1) { setAy(12); setYil(yil - 1); } else { setAy(ay - 1); }
  };
  const sonrakiAy = () => {
    if (ay === 12) { setAy(1); setYil(yil + 1); } else { setAy(ay + 1); }
  };

  return (
    <div className="kgs-container">
      <header className="kgs-header">
        <div className="kgs-header-sol">
          <h1>Kişisel Giderler</h1>
          <span className="kgs-alt">Ofis kasasından ayrıdır · yalnızca siz görürsünüz</span>
        </div>

        <div className="kgs-donem">
          <button type="button" className="kgs-ok" onClick={oncekiAy} aria-label="Önceki ay">‹</button>
          <select value={ay} onChange={(e) => setAy(parseInt(e.target.value, 10))} aria-label="Ay">
            {AYLAR.map((a) => <option key={a.value} value={a.value}>{a.label}</option>)}
          </select>
          <select value={yil} onChange={(e) => setYil(parseInt(e.target.value, 10))} aria-label="Yıl">
            {Array.from({ length: 6 }, (_, i) => new Date().getFullYear() - i)
              .map((y) => <option key={y} value={y}>{y}</option>)}
          </select>
          <button type="button" className="kgs-ok" onClick={sonrakiAy} aria-label="Sonraki ay">›</button>
        </div>
      </header>

      <KisiselGiderler yil={yil} ay={ay} hemenEkle={hemenEkle} />
    </div>
  );
};

export default KisiselGiderlerSayfasi;
